import { Route, Routes, Navigate } from "react-router-dom"
import { Provider } from "react-redux"
import { DashboardUser } from "@hydrologiq/common/providers/FirebaseAuth"
import store from "./state/store"
import Providers from "@hydrologiq/shared/providers/Providers"
import { RouteProvider, Section } from "@hydrologiq/shared/providers/RouteProvider"
import ScrollToTop from "@hydrologiq/shared/ScrollToTop"
import CalendarView from "@hydrologiq/planner/views/CalendarView"
import PlannerSelection from "./components/selection/PlannerSelection"

function Routing(props: { basePath?: string; user?: DashboardUser; container?: React.RefObject<HTMLElement> }) {
  const sectionPath = "planner"
  const { basePath = sectionPath, user, container } = props

  return (
    <Provider store={store}>
      <ScrollToTop />
      <Routes>
        {!basePath && <Route path={sectionPath} element={<Navigate to={"/"} />} />}
        <Route
          path={basePath}
          element={
            <RouteProvider route={basePath} section={Section.PLANNER}>
              <Providers container={container} user={user}>
                <PlannerSelection />
              </Providers>
            </RouteProvider>
          }
        >
          <Route index element={<CalendarView />} />
        </Route>
      </Routes>
    </Provider>
  )
}

export default Routing
